import { render, staticRenderFns } from "./subgame3.8.vue?vue&type=template&id=89fe78ac&scoped=true"
import script from "./subgame3.8.vue?vue&type=script&lang=js"
export * from "./subgame3.8.vue?vue&type=script&lang=js"
import style0 from "./subgame3.8.vue?vue&type=style&index=0&id=89fe78ac&prod&lang=css"
import style1 from "./subgame3.8.vue?vue&type=style&index=1&id=89fe78ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fe78ac",
  null
  
)

export default component.exports